/**************************************************************************************************/
/*   File: /src/app/shared/services/file/file.service.ts                                          */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import * as fromModels from '../../models';
import { HeaderService } from '../utils/header.service';

/**
 * The file service
 */
@Injectable({
  providedIn: 'root'
})
export class FileService {

  /**
   * The api url for authorization users
   */
  apiUrl = environment.serviceHost;
  /**
   * The api path
   */
  apiPath = environment.apiPath;
  /**
   * The geo data type api url
   */
  path = 'documentloc';
  /**
   * The constructor
   * @param http The http
   * @param headerService the header service 
   */
  constructor(private http: HttpClient, private headerService: HeaderService) {
  }
  /**
   * Create the file
   */
  createFile(file: fromModels.FileModel): Observable<fromModels.LocalDocumentId> {
    const formData = new FormData();
    // formData.append('file', file.buffer, file.buffer.name);
    /* istanbul ignore next */
    const data = file && file.rawData && file.rawData.size ? [file.rawData.slice()] : [];
    formData.append('file', new Blob(data), file.buffer.name);
    formData.append('centralizedDocument', environment.centralizedDocument.toString());
    const options = {
      headers: new HttpHeaders(),
      params: new HttpParams(),
      reportProgress: false,
    };

    return this.http.post<fromModels.LocalDocumentId>(
      `${this.apiUrl}${this.apiPath}${this.path}/create-file`,
      formData,
      options
    );
  }
  /**
   * Delete the document
   * @param fileId the file id to remove
   */
  deleteDocument(fileId: string, isUploaded: boolean): Observable<fromModels.Result> {

    if (!isUploaded) {
      const result = new fromModels.Result();
      result.result = true;
      return of(result);
    }
    return this.http.delete<fromModels.Result>(
      `${this.apiUrl}${this.apiPath}${this.path}/del-unlock/${fileId}`,
      this.headerService.getHeaders());
  }


}
